package com.eladfinish.bible.contest.screens.search.ai.remote

import com.eladfinish.bible.contest.network.ApiBaseUrlProvider
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class AiSearchApiImpl(
    private val httpClient: HttpClient,
    private val apiBaseUrlProvider: ApiBaseUrlProvider,
) : AiSearchApi {

    override suspend fun getAiSearchSuggestion(
        prompt: String,
    ): AiSearchSuggestionResponse {
        val response = httpClient.post(
            urlString = "${apiBaseUrlProvider.getBaseUrl()}/ai/search-expression",
        ) {
            contentType(ContentType.Application.Json)
            setBody(
                AiSearchRequest(
                    prompt = prompt,
                ),
            )
        }.body<AiSearchResponse>()

        if (!response.isValid) {
            throw IllegalStateException(
                response.errorMessage ?: "Invalid AI search expression",
            )
        }

        val expression = response.expression
            ?.trim()
            ?.takeIf(String::isNotEmpty)
            ?: throw IllegalStateException("AI search expression is empty")

        return AiSearchSuggestionResponse(
            expression = expression,
            explanation = response.explanation,
        )
    }
}
